import webhooks_gen_2 from '@devices/settings/device_settings/webhooks_gen_2.js';
import networks_gen_2_plus_sleeping from '@devices/settings/device_settings/networks_gen_2_plus_sleeping.js';
import appWithAI from '@devices/settings/device_settings/app_settings_temperature_with_ai.js';
import share from '@devices/settings/device_settings/share.js';
import bluetooth_gen_2 from '@devices/settings/device_settings/bluetooth_gen_2.js';

export default {
	name: 'ShellyHTG3',
	friendly_name: 'H&T G3',
	family: 'sensor',
	isPM: false,
	modes: {
		sensor: {
			channels: 1,
			notifications: ['offline', 'device_problem', 'lowBattery'],
			settings: [
				{
					title: 'sensor_settings',
					components: [
						{ title: 'temperature_unit', component: 'temperature_unit_g2' },
						{
							title: 'temperature_offset',
							component: 'temperature_offset_g2',
							min_ver: '0.11.4',
						},
						{
							title: 'humidity_offset',
							component: 'humidity_offset_g2',
							min_ver: '0.11.4',
						},
						{
							title: 'temperature_threshold',
							component: 'temperature_threshold_g2',
						},
						{ title: 'humidity_threshold', component: 'humidity_threshold_g2' },
					],
				},
				webhooks_gen_2,
				networks_gen_2_plus_sleeping,
				bluetooth_gen_2,
				appWithAI,
				share,
				{
					title: 'settings',
					components: [
						{ title: 'device_name', component: 'device_name_sys' },
						{ title: 'firmware_version', component: 'firmware_update' },
						{ title: 'geo_location_and_time_zone', component: 'location_g2' },
						{ title: 'device_reboot', component: 'device_reboot' },
						{ title: 'factory_reset', component: 'factory_reset' },
						{ title: 'device_information', component: 'device_information' },
					],
				},
			],
		},
	},
};
